import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {colors} from '../theme/colors';

const BottomTabs = () => {
  const location = useLocation();

  const tabs = [
    {path: '/', label: 'בית', icon: '🏠', name: 'Home'},
    {path: '/daily-values', label: 'ערכים', icon: '📊', name: 'DailyValues'},
    {path: '/food-diary', label: 'יומן', icon: '🍽️', name: 'FoodDiary'},
    {path: '/profile', label: 'פרופיל', icon: '👤', name: 'Profile'},
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div style={styles.container}>
      {tabs.map(tab => {
        const active = isActive(tab.path);
        return (
          <Link
            key={tab.path}
            to={tab.path}
            style={{
              ...styles.tab,
              color: active ? colors.primary : colors.textSecondary,
              backgroundColor: active ? colors.selection : 'transparent',
              borderBottom: active ? `3px solid ${colors.primary}` : '3px solid transparent',
              transform: active ? 'scale(1.05)' : 'scale(1)',
            }}
            aria-label={`Navigate to ${tab.name} screen`}
            aria-current={active ? 'page' : undefined}
            tabIndex={0}
            onMouseEnter={(e) => {
              if (!active) {
                e.currentTarget.style.backgroundColor = colors.selection;
                e.currentTarget.style.transform = 'scale(1.02)';
              }
            }}
            onMouseLeave={(e) => {
              if (!active) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}>
            <div 
              style={{
                ...styles.icon,
                transform: active ? 'scale(1.1)' : 'scale(1)',
              }}
              aria-hidden="true">
              {tab.icon}
            </div>
            <div style={styles.label}>{tab.label}</div>
          </Link>
        );
      })}
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: colors.surface,
    borderTop: `1px solid ${colors.border}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingTop: 12,
    paddingBottom: 'max(12px, env(safe-area-inset-bottom))',
    minHeight: 72,
    zIndex: 1000,
    boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.1)',
  },
  tab: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    flex: 1,
    padding: 12,
    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    borderRadius: 12,
    minHeight: 48,
    position: 'relative',
  },
  icon: {
    fontSize: 28,
    marginBottom: 4,
    transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  label: {
    fontSize: 12,
    fontWeight: '600',
    letterSpacing: 0.3,
    transition: 'color 300ms ease',
  },
};

export default BottomTabs;

